import { FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';

export type NetworkInterfaceValue = 'default' | 'wan0' | 'wan1' | 'cellular';

export const NETWORK_INTERFACE_OPTIONS: { value: NetworkInterfaceValue; label: string }[] = [
  { value: 'default', label: 'Current Active WAN' },
  { value: 'wan0', label: 'Primary WAN' },
  { value: 'wan1', label: 'Secondary WAN' },
  { value: 'cellular', label: 'Cellular' },
];

export const formatNetworkInterface = (value?: string | null) =>
  NETWORK_INTERFACE_OPTIONS.find((opt) => opt.value === value)?.label || 'Current Active WAN';

interface NetworkInterfaceSelectProps {
  value: NetworkInterfaceValue;
  onChange: (value: NetworkInterfaceValue) => void;
  // When true, only the current value stays selectable — every other option
  // is disabled (used when a connection/session is already pinned to an
  // interface and shouldn't be changed from here).
  locked?: boolean;
  lockedMessage?: string;
}

export const NetworkInterfaceSelect = ({ value, onChange, locked, lockedMessage }: NetworkInterfaceSelectProps) => (
  <>
    <RadioGroup
      value={value}
      onChange={(e) => onChange(e.target.value as NetworkInterfaceValue)}
      sx={{ mb: locked ? 2 : 5 }}
    >
      {NETWORK_INTERFACE_OPTIONS.map(({ value: optionValue, label }) => (
        <FormControlLabel
          key={optionValue}
          value={optionValue}
          control={<Radio />}
          label={label}
          disabled={locked && optionValue !== value}
        />
      ))}
    </RadioGroup>
    {locked && (
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        {lockedMessage || 'This connection is already pinned to this interface.'}
      </Typography>
    )}
  </>
);
